(function () {
  "use strict";

  var FILTERS_SELECTOR = "[data-vp-blog-filters]";
  var GROUPS_CONTAINER_SELECTOR = "[data-vp-filter-groups]";
  var ARTICLES_CONTAINER_SELECTOR = ".blog-post-list, blog-posts";
  var ARTICLE_CARD_SELECTOR = ".vp-article-card-wrapper";
  var RESET_SELECTOR = "[data-vp-filter-reset]";
  var PAGINATION_SELECTOR = "nav.pagination";

  var CATEGORIES = [
  { key: "themenbereich", label: "Themenbereiche" },
  { key: "einsatzgebiet", label: "Einsatzgebiete" },
  { key: "inhaltsstoff", label: "Inhaltsstoffe" }
  ];

  var allArticlesLoaded = false;
  var allArticlesLoading = null;

  function init() {
  var filtersContainer = document.querySelector(FILTERS_SELECTOR);
  var articlesContainer = document.querySelector(ARTICLES_CONTAINER_SELECTOR);
  if (!filtersContainer || !articlesContainer) return;

  var groupsContainer = filtersContainer.querySelector(GROUPS_CONTAINER_SELECTOR);
  var resetButton = filtersContainer.querySelector(RESET_SELECTOR);

  var rawTags = filtersContainer.getAttribute("data-vp-all-tags") || "";
  var allTags = rawTags.split("|").map(function (t) {
  return t.trim().toLowerCase();
  }).filter(function (t) {
  return t.length > 0;
  });

  if (allTags.length === 0) {
  groupsContainer.innerHTML = '<p style="font-size:14px;color:#777;padding:16px 0;">Noch keine Filter-Tags vergeben.</p>';
  return;
  }

  var groups = {};
  CATEGORIES.forEach(function (cat) { groups[cat.key] = {}; });
  allTags.forEach(function (tag) {
  var colonIndex = tag.indexOf(":");
  if (colonIndex !== -1) {
  var category = tag.substring(0, colonIndex);
  var value = tag.substring(colonIndex + 1).trim();
  if (groups[category] && value) {
  groups[category][value] = (groups[category][value] || 0) + 1;
  }
  }
  });

  renderGroups(groupsContainer, groups);
  annotateArticles(articlesContainer);
  applyInitialStateFromHash(filtersContainer);

  var checkboxes = filtersContainer.querySelectorAll("[data-vp-filter-tag]");
  checkboxes.forEach(function (cb) {
  cb.addEventListener("change", function () {
  applyFilters(filtersContainer, articlesContainer, resetButton);
  });
  });
  if (resetButton) {
  resetButton.addEventListener("click", function () {
  checkboxes.forEach(function (cb) { cb.checked = false; });
  applyFilters(filtersContainer, articlesContainer, resetButton);
  });
  }

  applyFilters(filtersContainer, articlesContainer, resetButton);
  }

  function getActiveTags(filtersContainer) {
  var activeTags = [];
  filtersContainer.querySelectorAll("[data-vp-filter-tag]").forEach(function (cb) {
  if (cb.checked) {
  activeTags.push((cb.getAttribute("data-vp-filter-tag") || "").toLowerCase());
  }
  });
  return activeTags;
  }

  function applyFilters(filtersContainer, articlesContainer, resetButton) {
  var activeTags = getActiveTags(filtersContainer);
  writeTagsToHash(activeTags);

  if (activeTags.length === 0) {
  renderVisibility(articlesContainer, activeTags);
  setPaginationHidden(false);
  if (resetButton) resetButton.setAttribute("hidden", "");
  showEmptyStateIfNeeded(articlesContainer, activeTags);
  return;
  }

  if (resetButton) resetButton.removeAttribute("hidden");

  ensureAllArticlesLoaded(articlesContainer).then(function () {
  annotateArticles(articlesContainer);
  renderVisibility(articlesContainer, activeTags);
  setPaginationHidden(true);
  showEmptyStateIfNeeded(articlesContainer, activeTags);
  });
  }

  function renderVisibility(articlesContainer, activeTags) {
  var cards = articlesContainer.querySelectorAll(ARTICLE_CARD_SELECTOR);
  cards.forEach(function (card) {
  if (activeTags.length === 0) {
  card.style.display = card.getAttribute("data-vp-extra") === "1" ? "none" : "";
  return;
  }
  var cardTags = card._vpTags || [];
  var matchesAll = activeTags.every(function (activeTag) {
  return cardTags.indexOf(activeTag) !== -1;
  });
  card.style.display = matchesAll ? "" : "none";
  });
  }

  function setPaginationHidden(hidden) {
  var styleId = "vp-blog-filters-style";
  if (!document.getElementById(styleId)) {
  var st = document.createElement("style");
  st.id = styleId;
  st.textContent = "body.vp-blog-filtered " + PAGINATION_SELECTOR + "{display:none !important;}";
  document.head.appendChild(st);
  }
  document.body.classList.toggle("vp-blog-filtered", hidden);
  }

  function ensureAllArticlesLoaded(articlesContainer) {
  if (allArticlesLoaded) return Promise.resolve();
  if (allArticlesLoading) return allArticlesLoading;

  var basePath = window.location.pathname;
  var maxPage = 1;
  document.querySelectorAll('a[href*="page="]').forEach(function (a) {
  var m = (a.getAttribute("href") || "").match(/[?&]page=(\d+)/);
  if (m) {
  var n = parseInt(m[1], 10);
  if (n > maxPage) maxPage = n;
  }
  });

  if (maxPage < 2) {
  allArticlesLoaded = true;
  return Promise.resolve();
  }

  var existing = {};
  articlesContainer.querySelectorAll(ARTICLE_CARD_SELECTOR).forEach(function (c) {
  existing[cardKey(c)] = true;
  });

  var requests = [];
  for (var p = 2; p <= maxPage; p++) {
  requests.push(fetchPageCards(basePath, p));
  }

  allArticlesLoading = Promise.all(requests).then(function (pages) {
  pages.forEach(function (cards) {
  cards.forEach(function (card) {
  var k = cardKey(card);
  if (existing[k]) return;
  existing[k] = true;
  card.setAttribute("data-vp-extra", "1");
  card.style.display = "none";
  articlesContainer.appendChild(card);
  });
  });
  allArticlesLoaded = true;
  }).catch(function () {
  allArticlesLoaded = true;
  });

  return allArticlesLoading;
  }

  function fetchPageCards(basePath, page) {
  return fetch(basePath + "?page=" + page, { credentials: "same-origin" })
  .then(function (r) { return r.ok ? r.text() : ""; })
  .then(function (html) {
  if (!html) return [];
  var doc = new DOMParser().parseFromString(html, "text/html");
  var container = doc.querySelector(ARTICLES_CONTAINER_SELECTOR);
  if (!container) return [];
  return Array.prototype.slice
  .call(container.querySelectorAll(ARTICLE_CARD_SELECTOR))
  .map(function (c) { return document.importNode(c, true); });
  })
  .catch(function () { return []; });
  }

  function cardKey(card) {
  var link = card.querySelector('a[href*="/blogs/"]');
  return link ? link.getAttribute("href") : "";
  }

  function renderGroups(container, groups) {
  var html = "";
  CATEGORIES.forEach(function (cat) {
  var values = groups[cat.key];
  var valueKeys = Object.keys(values);
  if (valueKeys.length === 0) return;
  valueKeys.sort();
  html += '<details class="vp-blog-filters__group" open>';
  html += '<summary class="vp-blog-filters__group-summary">';
  html += "<span>" + escapeHtml(cat.label) + "</span>";
  html += '<svg class="vp-blog-filters__group-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><polyline points="6 9 12 15 18 9"></polyline></svg>';
  html += "</summary>";
  html += '<ul class="vp-blog-filters__list" role="list">';
  valueKeys.forEach(function (value) {
  var count = values[value];
  var fullTag = cat.key + ":" + value;
  var prettyLabel = prettifyValue(value);
  html += '<li class="vp-blog-filters__item">';
  html += '<label class="vp-blog-filters__label">';
  html += '<input type="checkbox" class="vp-blog-filters__checkbox" data-vp-filter-tag="' + escapeAttr(fullTag) + '" data-vp-filter-category="' + escapeAttr(cat.key) + '" value="' + escapeAttr(value) + '">';
  html += '<span class="vp-blog-filters__label-text">' + escapeHtml(prettyLabel) + "</span>";
  html += '<span class="vp-blog-filters__count">(' + count + ")</span>";
  html += "</label>";
  html += "</li>";
  });
  html += "</ul>";
  html += "</details>";
  });
  container.innerHTML = html;
  }

  function annotateArticles(articlesContainer) {
  var cards = articlesContainer.querySelectorAll(ARTICLE_CARD_SELECTOR);
  cards.forEach(function (card) {
  if (card._vpTags) return;
  var raw = card.getAttribute("data-vp-article-tags") || "";
  card._vpTags = raw.split(",").map(function (t) {
  return t.trim().toLowerCase();
  }).filter(function (t) {
  return t.length > 0;
  });
  });
  }

  function applyInitialStateFromHash(filtersContainer) {
  var hash = window.location.hash || "";
  if (hash.indexOf("#filter=") !== 0) return;
  var encoded = hash.substring(8);
  var initialTags;
  try {
  initialTags = decodeURIComponent(encoded).split(",").map(function (t) {
  return t.trim().toLowerCase();
  }).filter(function (t) {
  return t.length > 0;
  });
  } catch (e) {
  return;
  }
  filtersContainer.querySelectorAll("[data-vp-filter-tag]").forEach(function (cb) {
  var tag = (cb.getAttribute("data-vp-filter-tag") || "").toLowerCase();
  if (initialTags.indexOf(tag) !== -1) cb.checked = true;
  });
  }

  function writeTagsToHash(tags) {
  if (!window.history || !window.history.replaceState) return;
  if (tags.length === 0) {
  window.history.replaceState(null, "", window.location.pathname + window.location.search);
  } else {
  window.history.replaceState(null, "", "#filter=" + encodeURIComponent(tags.join(",")));
  }
  }

  function showEmptyStateIfNeeded(articlesContainer, activeTags) {
  var cards = articlesContainer.querySelectorAll(ARTICLE_CARD_SELECTOR);
  var visibleCount = 0;
  cards.forEach(function (card) {
  if (card.style.display !== "none") visibleCount++;
  });
  var emptyEl = articlesContainer.parentNode.querySelector(".vp-blog-filters__empty");
  if (!emptyEl) {
  emptyEl = document.createElement("div");
  emptyEl.className = "vp-blog-filters__empty";
  emptyEl.innerHTML = "<p>Keine Artikel gefunden, die alle gewaehlten Filter erfuellen. Versuche, einen Filter zu entfernen.</p>";
  articlesContainer.parentNode.appendChild(emptyEl);
  }
  emptyEl.style.display = (visibleCount === 0 && activeTags.length > 0) ? "" : "none";
  }

  function prettifyValue(value) {
  return value.replace(/-/g, " ").replace(/\b\w/g, function (c) {
  return c.toUpperCase();
  });
  }

  function escapeHtml(s) {
  return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  }

  function escapeAttr(s) {
  return String(s).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
  }

  if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
  } else {
  init();
  }
  })();
